const freeClinicState = {
  freeAnsCount: 50 // 专家免费回答数
};

export default freeClinicState;



// WEBPACK FOOTER //
// ./src/store/user/state.freeClinic.js